import { createContext, useContext } from 'react'
import { NavigationConfig } from './types'

export const NavigationContext = createContext<NavigationConfig | null>(null)

export function useNavigation() {
  const value = useContext(NavigationContext)
  if (!value) {
    throw new Error('useNavigation was used outside of AppLayout')
  }
  return value
}
